module.exports = __webpack_public_path__ + "img/ic24ArrowD.f01719b0.svg";